<template>
    <div class="ldzmain">
        <div class="pic">
            <img :src="list.picUrl" alt="">
        </div>
        <div class="xxxx">
            <van-field v-model="list.manageName"  label="姓名" placeholder="暂无" input-align="right"  readonly></van-field>
            <van-field v-model="list.managePhone"  label="联系方式" placeholder="暂无" input-align="right"  readonly></van-field>
            <van-field v-model="list.no"  label="负责楼栋" placeholder="暂无" input-align="right"  readonly></van-field>
            <div class="monicell">
                <div class="zz">
                    <div class="zctitle">
                        <span>工作职责</span>
                    </div>
                    <div class="srfw ">
                        {{list.duty}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:{}
        }
    },
    mounted() {
        this.getdata()
    },
    methods: {
        getdata(){
            this.$axios.get('/api/v1/wygl/buildingmanager/viewone', {
				params: {
                    buildingManagerId:this.$route.query.id
                }
			}).then(res => {
                this.list = res
			});
        }
    },
}
</script>
<style lang="less" scoped>
    .ldzmain{
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .pic{
            height: 170px;
            width: 130px;
            margin-top: 10px;
            img{
                height: 100%;
                width: 100%;
            }
        }
        .xxxx{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 10px;
            width: 94%;
            margin-left: 3%;
            .xx{
                width: 80%;
                display: flex;
                align-items: center;
                margin-top: 10px;
            }
            .monicell{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .zz{
                    margin:10px 16px;
                    width:100%;
                    display: flex;
                }
                .zctitle{
                    width: 40%;
                    color: #646566;
                    font-size: 14px;
                }
                .srfw{
                    font-size: 14px;
                    width: 60%;
                    display: flex;
                    justify-content: flex-end;
                    white-space: pre-wrap;
                }
            }
        }
    }
</style>